import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { GeneralService } from '../general.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TravelModalComponent } from '../travel-modal/travel-modal.component';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { ViewCertComponent } from '../view-cert/view-cert.component';
import { ClaimsFormComponent } from '../claims-form/claims-form.component';

@Component({
  selector: 'app-policy-details',
  templateUrl: './policy-details.component.html',
  styleUrls: [
    '../dasboard/dasboard.component.css',
    '../create-policy/create-policy.component.css',
    './policy-details.component.css',
  ],
})
export class PolicyDetailsComponent implements OnInit {
  constructor(
    private s: GeneralService,
    private toaster: ToastrService,
    private r: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) {
    this.user = JSON.parse(localStorage.getItem('user')!);
  }

  grossDetail: any;
  persons = [];
  transaction: any;
  show = false;
  id: string = '';
  user: { [key: string]: string } = {};

  ngOnInit(): void {
    if (this.route.snapshot.params['chnl']) {
      this.show = true;
    }
    this.id = this.route.snapshot.params['id'];
    this.s.getPolicyDetails(this.id).subscribe((r: any) => {
      this.grossDetail = r['Traveller Info'];
      this.transaction = r['Transaction'];
      this.s
        .getDestination(this.grossDetail['country_id'])
        .subscribe((r: any) => {
          this.s.loader = false;
          this.grossDetail['countryName'] = r.countryName;
        });
      this.persons = r['Users Info'];
      console.log(r);
    });
  }
  calcNet(val: string) {
    return parseFloat(val) * 0.8;
  }
  calcCommission(val: string) {
    return parseFloat(val) - parseFloat(val) * 0.8;
  }
  makePyt() {
    let data = {
      // amount: 1000,
      amount: this.grossDetail['grossPremium'],
      policy_detail_id: this.grossDetail['_id'],
      type: 'cash',
    };
    // console.log(datas)
    // this.s.makePyt(datas).subscribe((data) => {
    //   console.log(data);
    //   this.s.loader = false;
    //   this.toaster.warning(
    //     'Do not attempt to close the modal, you might lose your transaction details'
    //   );
    //   this.toaster.info(
    //     'Click the finish button once you complete the transaction'
    //   );
    let dialogRef = this.dialog.open(TravelModalComponent, {
      data,
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((r: any) => {
      console.log(r);
      if (r.action == 'success') {
        this.toaster.success(
          "successfully purchased a policy. You'd receive a message from us in no time."
        );
        this.r.navigateByUrl('main/dashboard');
      }
    });
    // });
  }
  editCert(id: string) {
    this.r.navigateByUrl('main/request-edit/' + id);
  }
  viewCert(url: string) {
    let data = { url: url };
    let dialogRef = this.dialog.open(ViewCertComponent, {
      data,
      height: '80vh',
      width: '50vw',
    });
  }
  retrigerCertificate(policy_detail_id:string) {
    
    let dialogRef = this.dialog.open(ViewCertComponent)
    dialogRef.afterClosed().subscribe((r: any) => {
      if(r){
        this.s.retrigerCertificate({policy_detail_id})
        .subscribe((r)=>{
          this.s.loader = false
          console.log(r)
          if(r.errors.length == 0){
            window.location.reload()
          }
        })
      }
    })

  }

  claim() {
    this.cdr.detectChanges();

    const destination = this.grossDetail['countryName'];
    const packageName = this.grossDetail['categoryName'];
    const gross_premium = this.grossDetail['grossPremium']; 
    const number_of_days = this.grossDetail['numberOfDay'];
    const payment_plan = this.grossDetail['payment_plan'];
    const startDate = this.grossDetail['startDate'];
    const endDate = this.grossDetail['endDate'];
    const policy_number = this.persons[0]['policyNo'];
    const policy_detail_id = this.persons[0]['policy_detail_id'];
    const email = this.transaction['email'];

    const travelData = {
      destination,
      packageName,
      gross_premium,
      number_of_days,
      payment_plan,
      startDate,
      endDate,
      email,
      policy_number,
      policy_detail_id
    };

    this.dialog.open(ClaimsFormComponent, {
      data: travelData,
      width: '30vw',
      height: '80vh',
      disableClose: true,
    }); 
  }
}
